import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  scheduleClassesFormAcademyScheduleSelector,
  setScheduleClassesFormAcademySchedule,
} from 'features/classCreation';
import AcademyScheduleSelect from 'components/AcademyScheduleSelect';
import styles from './ClassesScheduleSelect.module.scss';

function ClassesScheduleSelect() {
  const dispatch = useDispatch();
  const academySchedule = useSelector(
    scheduleClassesFormAcademyScheduleSelector
  );

  const handleChange = useCallback(
    (value) => {
      dispatch(setScheduleClassesFormAcademySchedule(value));
    },
    [dispatch]
  );

  return (
    <AcademyScheduleSelect
      className={classNames(styles.root, 'm-r-xs m-b-xs')}
      onChange={handleChange}
      value={academySchedule}
    />
  );
}

export default ClassesScheduleSelect;
